import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ShopSellerBatchService } from '../../../core/services/shop-seller/shop-seller-batch.service';
import { ShopSellerBatchInfoItemModel, ShopSellerBatchInfoModel } from '../../../core/models/shop-seller/shop-seller-batch.model';
import { LoadingComponent } from '../../../shared/components/loading/loading.component';
import { AlertComponent } from '../../../shared/components/alert/alert.component';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import {
  createPaginationState,
  setPaginationLoading,
  updatePaginationFromResult,
} from '../../../core/helpers/pagination-state.helper';
import {PaginationComponent} from '../../../shared/components/pagination/pagination.component';

@Component({
  selector: 'app-shop-sellers-batch-detail',
  standalone: true,
  imports: [CommonModule, TranslateModule, LoadingComponent, AlertComponent, ButtonComponent, ModalComponent, PaginationComponent],
  templateUrl: './shop-sellers-batch-detail.component.html',
  styleUrl: './shop-sellers-batch-detail.component.scss'
})
export class ShopSellersBatchDetailComponent implements OnInit {
  batchId!: string;
  error: string | null = null;
  batch: ShopSellerBatchInfoModel | null = null;

  selectedItem: ShopSellerBatchInfoItemModel | null = null;
  modalJsonContent: string = '';

  readonly paginationState = createPaginationState();

  @ViewChild('jsonModal') jsonModalRef!: ModalComponent;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly service: ShopSellerBatchService
  ) {}

  ngOnInit(): void {
    this.batchId = this.route.snapshot.paramMap.get('id') as string;
    this.fetchBatch();
  }

  fetchBatch(): void {
    if (!this.batchId) {
      this.error = 'ID do lote não informado.';
      return;
    }

    this.onPageChange(0, this.paginationState().itemsPerPage);
  }

  openJson(item: ShopSellerBatchInfoItemModel): void {
    this.selectedItem = item;
    // payload is a string in the model. Try to pretty print JSON, fallback to raw string.
    try {
      const parsed = JSON.parse(item.payload);
      this.modalJsonContent = JSON.stringify(parsed, null, 2);
    } catch (e) {
      this.modalJsonContent = item.payload as unknown as string;
    }
    this.jsonModalRef.openDialog();
  }

  operationType(op: string): string {
    switch (op) {
      case 'ADD':
        return 'Criação';
      case 'UPD':
        return 'Atualização';
      case 'DEL':
        return 'Exclusão';
      case 'NOP':
        return 'Inalterado';
      default:
        return 'UNKNOWN';
    }
  }

  operationStatus(httpStatusCode: number, op: string) {
    if (httpStatusCode >= 200 && httpStatusCode < 300) {
      return `Sucesso (${httpStatusCode})`;
    } else if (httpStatusCode >= 400 && httpStatusCode < 500) {
      return `Falha no payload (${httpStatusCode})`;
    } else if (httpStatusCode >= 500 && httpStatusCode < 600) {
      return `Falha no servidor (${httpStatusCode})`;
    }
    if (op === 'NOP') {
      return 'Inalterado';
    }
    return 'Desconhecido';
  }

  onPageChange = (page: number, pageSize: number): void => {
    setPaginationLoading(this.paginationState, true);
    this.error = null;

    this.service.getBatch(this.batchId, page, pageSize).subscribe({
      next: (res) => {
        this.batch = res;
        updatePaginationFromResult(this.paginationState, res.items, res.items.page.size ?? pageSize);
      },
      error: (err) => {
        console.error(err);
        this.error = 'Falha ao carregar o lote.';
        setPaginationLoading(this.paginationState, false);
      }
    });
  }
}
